/** A HUD meter. The bar is visual only; the value is always given in words (`describe`) for screen readers. */
export function Meter({ label, value, max = 100, word, tone, describe }: {
  label: string; value: number; max?: number; word?: string | undefined; tone: "en" | "pc" | "low"; describe: string;
}) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className="hud-item hud-meter">
      <span className="visually-hidden">{describe}</span>
      <span className="hud-label" aria-hidden="true">{label}</span>
      <span className="meter" aria-hidden="true">
        <span className={`meter__fill meter__fill--${tone}`} style={{ width: `${pct}%` }} />
      </span>
      <span className="hud-value" aria-hidden="true">{word ?? value}</span>
    </div>
  );
}
